import app from 'flarum/common/app';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import extractText from 'flarum/common/utils/extractText';
import Widget from 'ext:fof/forum-widgets-core/common/components/Widget';
const KEY = 'swtorpolska-group-legend';
export function legendGroups() {
  return app.forum.attribute(`${KEY}.legend`) || [];
}
export default class GroupLegendWidget extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.attrs.state.open ??= null; // id rozwiniętej grupy
  }
  className() {
    return 'GroupLegendWidget';
  }
  icon() {
    return 'fas fa-users';
  }
  title() {
    return extractText(app.translator.trans(`${KEY}.forum.widget.title`));
  }
  content() {
    const groups = legendGroups();
    const showCounts = app.forum.attribute(`${KEY}.showCounts`) !== false;
    const singular = !!app.forum.attribute(`${KEY}.singularNames`);
    const showMembers = app.forum.attribute(`${KEY}.showMembers`) !== false;
    if (!groups.length) {
      return m("p", {
        className: "GroupLegendWidget-empty"
      }, app.translator.trans(`${KEY}.forum.widget.empty`));
    }
    return m("ul", {
      className: "GroupLegendWidget-list"
    }, groups.map(group => {
      const open = this.attrs.state.open === group.id;
      const expandable = showMembers && group.members && group.members.length > 0;
      const color = group.color || 'var(--muted-color)';
      return m("li", {
        className: 'GroupLegendWidget-group' + (open ? ' is-open' : ''),
        style: {
          '--group-color': color
        }
      }, m("button", {
        type: "button",
        className: "GroupLegendWidget-row",
        disabled: !expandable,
        "aria-expanded": expandable ? String(open) : undefined,
        onclick: () => {
          this.attrs.state.open = open ? null : group.id;
        }
      }, m("span", {
        className: "GroupLegendWidget-badge"
      }, group.icon ? m(Icon, {
        name: group.icon
      }) : null), m("span", {
        className: "GroupLegendWidget-name"
      }, singular ? group.nameSingular || group.name : group.name), showCounts ? m("span", {
        className: "GroupLegendWidget-count"
      }, group.count) : null, expandable ? m(Icon, {
        name: open ? 'fas fa-chevron-up' : 'fas fa-chevron-down',
        className: "GroupLegendWidget-caret"
      }) : null), open && expandable ? m("div", {
        className: "GroupLegendWidget-members"
      }, group.members.map(user => m(Link, {
        className: "GroupLegendWidget-member",
        href: app.route('user', {
          username: user.slug
        })
      }, user.avatarUrl ? m("img", {
        className: "GroupLegendWidget-avatar",
        src: user.avatarUrl,
        alt: "",
        loading: "lazy"
      }) : m("span", {
        className: "GroupLegendWidget-avatar GroupLegendWidget-avatar--letter"
      }, (user.name || '?').charAt(0).toUpperCase()), m("span", {
        className: "GroupLegendWidget-memberName"
      }, user.name))), group.count > group.members.length ? m("span", {
        className: "GroupLegendWidget-more"
      }, app.translator.trans(`${KEY}.forum.widget.more`, {
        count: group.count - group.members.length
      })) : null) : null);
    }));
  }
}
flarum.reg.add('swtorpolska-group-legend', 'common/components/GroupLegendWidget', GroupLegendWidget);